import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';

const LoadingIndicator = ({ sending }) => {
  if (!sending) return null;
  
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
      <CircularProgress size={24} sx={{ color: ColorPalette.secondary }} />
      <Typography variant="body1" sx={{ marginLeft: '10px' }}>
        Enviando mensagens...
      </Typography>
    </Box>
  );
};

export default LoadingIndicator;